// extracted by mini-css-extract-plugin
module.exports = {"submitModal":"submitModal--1ee7m","buttonWrapper":"buttonWrapper--1ZkvQ"};